// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"152":"be41366e","296":"f31f924d","847":"899a7543"}[chunkId] + ".js";
};